import type {allSitesConst} from 'src/biz_spa/modules/sitesConst'

export const menuCategories = ['food', 'lunch', 'drink', 'takeout'] as const
export type MenuCategory = typeof menuCategories[number]
export type ServiceType = typeof allSitesConst[number]['siteType']

export { csvImportErrorStatus, csvErrorAttributes, csvErrorReasons } from './csvError'
type CategoryItemMaxLimits = {
  [K in ServiceType]?: number | null;
};

// アイテムの上限が決まっているサービスの配列
export const servicesWithItemLimits: ServiceType[] = ['gnavi', 'tabelog', 'hot_pepper_gourmet']

export const categoryItemMaxLimits: CategoryItemMaxLimits = {
  'google': null,
  'docomo': null,
  'retty': null,
  'gnavi': 100,
  'tabelog': 120,
  'hot_pepper_gourmet': 99,
}
